<template>
    <div class="help-center-tab">
        <b-button
            v-for="tab in tabs"
            :key="tab"
            size="lg"
            variant="transparent"
            :pressed="selectedHelpCenterTab === tab"
            class="nav-button"
            @click="$emit('onTabClick', tab)"
        >
            {{ $translate(tab) }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'HelpCenterTab',
    props: {
        selectedHelpCenterTab: {
            required: true,
            type: String
        }
    },
    data: () => ({
        tabs: ['tutorials', 'manuals', 'faqs']
    })
}
</script>

<style lang="scss" scoped>
.help-center-tab {
    display: flex;

    .nav-button {
        text-transform: capitalize;
        padding: 1rem;
        border-radius: 0;

        @media screen and #{$new-break1} {
            font-size: 0.85rem;
        }
        @media screen and #{$new-break2open} {
            font-size: 1rem;
        }
    }

    @media screen and #{$new-break3close} {
        background: $dark-3;

        .nav-button {
            border-bottom: 3px solid $dark-3 !important;

            &.active {
                border-bottom: 3px solid $blue !important;
            }
        }
    }
    @media screen and #{$new-break4open} {
        padding-top: 3rem;
    }
}
</style>
